import React from "react";
import { AssortGroup } from "../../../models/AssortGroup";
import getId from "../../../../utils/getId";

interface IProps {
  assortGroup: AssortGroup[][];
  currentPage: number;
  onSelect: (value: AssortGroup) => void;
  activeGroup: AssortGroup;
}

const MenuButtons: React.FC<IProps> = ({ assortGroup, currentPage, onSelect, activeGroup }: IProps) => {
  return (
    <div className={"bar-menu"}>
      {assortGroup[currentPage].map((value: AssortGroup, index: number) => (
        <div
          key={index}
          className={`bar-menu-btn ${getId(value) === getId(activeGroup) ? "active" : ""}`}
          onClick={() => onSelect(value)}
        >
          <img src={value.pictureUrl} alt={value.name} />
          <p>{value.name}</p>
        </div>
      ))}
    </div>
  );
};

export default MenuButtons;
